import { Skeleton } from '@avanta/shared/components/ui/Skeleton';
import { FLOW_MODES } from '@avanta/shared/constants/appointments';
import { cn } from '@avanta/shared/utils/cn';
import { useFormContext, useWatch } from 'react-hook-form';
import { SessionSummarySkeleton } from 'pages/AppointmentsReserve/components/ui/SessionSummary/SessionSummarySkeleton';
import { StepSection } from 'pages/AppointmentsReserve/components/ui/StepSection';
import { AppointmentsReservePayload } from 'pages/AppointmentsReserve/constants';
import { type AppointmentsReserveFormData } from 'pages/AppointmentsReserve/types';

const FIELDS_PER_SECTION = 2;

const SelectFieldSkeleton = (): React.ReactElement => (
  <div className="flex flex-col gap-2">
    <Skeleton className="h-3.5 w-24" />
    <Skeleton className="h-10 w-full rounded-lg" />
  </div>
);

export const DataStepSkeleton = (): React.ReactElement => {
  const { control } = useFormContext<AppointmentsReserveFormData>();
  const flow = useWatch({ control, name: AppointmentsReservePayload.flow });
  const showBackButton = flow === FLOW_MODES.search_patient;

  return (
    <div className="flex w-full max-w-241 flex-col gap-12">
      <div className="flex gap-8">
        <SessionSummarySkeleton
          sections={{ dateTime: false, patient: true, service: false, psychologist: false }}
        />
        <StepSection
          title={<Skeleton className="h-5 w-40" />}
          className="grid grid-cols-2 gap-6"
          containerClassName="w-full flex-1"
        >
          {Array.from({ length: FIELDS_PER_SECTION }, (_field, index) => (
            <SelectFieldSkeleton key={`select-${index}`} />
          ))}
        </StepSection>
      </div>
      <div className={cn('flex w-full justify-end', showBackButton && 'justify-between')}>
        {showBackButton ? <Skeleton className="h-10 w-28 rounded-xl" /> : null}
        <Skeleton className="h-10 w-37 min-w-37 rounded-xl" />
      </div>
    </div>
  );
};
